import React, { useState } from 'react';

import { 
  Card, 
  MarginTop,
  MarginBottom,
  CardContain
} from '../Account/Styled';

import StripeAddCard from '../Account/StripeAddCard';

import Text from 'components/Text';
import Button from 'components/Button';

import { ACCOUNT_CARD } from 'constants/errors';
import Conditional from 'components/Conditional';
import { ErrorMessage } from 'components/ErrorMessage';

export const AddCard = ({
  addAccountCard,
  userIsAdmin,
}) => {

  const [error, setError] = useState(false);

  var addCardHandler = (stripe) => {
    setError(false);

    stripe
      .createToken({ name: 'searchlight_account_card' })
      .then((res) => {
        if (!res.token) {

          if (res.error) {
            setError({ ...res.error, type: ACCOUNT_CARD })
          }
        } else {
            addAccountCard({ stripe_source_id: res.token.id }); 
        }

      })
      .catch((err) => {
        console.log("error in the catch", err)
        return;
      });
  };

  return (
    <CardContain>
      <Card>
        <div style={{ maxWidth: 640 }}>
          <MarginBottom>
            <Text.Info>Add an account card</Text.Info>
          </MarginBottom>

          <Conditional show={true}>
            <StripeAddCard
              renderSubmit={(stripe) => userIsAdmin && (
                <MarginTop>
                  <Button.Default
                    inline
                    label="Add Card"
                    onClick={addCardHandler.bind(null, stripe)}
                  />
                </MarginTop>
              )}
            />
          </Conditional>
          <ErrorMessage error={error} />
        </div>
      </Card>
    </CardContain>
  );
};

export default AddCard;
